import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/** 和首屏 HTML 共用服务端规则，切换页面时更新分享信息与结构化数据。 */
export default function Meta() {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const abort = new AbortController();
    fetch(
      "/api/basic/seo?path=" +
        encodeURIComponent(location.pathname + location.search),
      { signal: abort.signal }
    )
      .then((response) => {
        if (!response.ok) throw new Error("SEO unavailable");
        return response.json();
      })
      .then(({ data }) => {
        if (abort.signal.aborted) return;
        if (data.redirect) {
          if (/^https?:\/\//.test(data.redirect))
            window.location.replace(data.redirect);
          else navigate(data.redirect, { replace: true });
          return;
        }
        document.title = data.title;
        for (const [key, value] of Object.entries({
          description: data.description,
          keywords: data.keywords,
          robots: data.robots,
          "og:title": data.title,
          "og:description": data.description,
          "og:url": data.canonical,
          "og:site_name": data.siteName,
          "og:type": data.type,
          "og:locale": "zh_CN",
          "og:image": data.image,
          "og:image:width": "1200",
          "og:image:height": "630",
          "og:image:alt": data.siteName + "：AI电商实战工具箱",
          "twitter:card": "summary_large_image",
          "twitter:title": data.title,
          "twitter:description": data.description,
          "twitter:image": data.image,
        })) {
          const attr = key.startsWith("og:") ? "property" : "name";
          let element = document.head.querySelector(`meta[${attr}="${key}"]`);
          if (!element) {
            element = document.createElement("meta");
            element.setAttribute(attr, key);
            document.head.appendChild(element);
          }
          element.setAttribute("content", String(value || ""));
        }
        let canonical = document.head.querySelector<HTMLLinkElement>(
          'link[rel="canonical"]'
        );
        if (!data.canonical) canonical?.remove();
        else {
          if (!canonical) {
            canonical = document.createElement("link");
            canonical.rel = "canonical";
            document.head.appendChild(canonical);
          }
          canonical.href = data.canonical;
        }
        let schema = document.getElementById(
          "site-schema"
        ) as HTMLScriptElement | null;
        if (!schema) {
          schema = document.createElement("script");
          schema.id = "site-schema";
          schema.type = "application/ld+json";
          document.head.appendChild(schema);
        }
        schema.textContent = JSON.stringify(data.structuredData);
      })
      .catch(() => {
        /* 保留首屏 HTML 的有效元数据，下一次导航重试。 */
      });
    return () => abort.abort();
  }, [location.pathname, location.search, navigate]);
  return null;
}
